'use client';

import { useSearchInputs } from '@liquorice/next-search';
import { TextField, TextFieldProps } from '@mui/material';
import Icon from '../Icon';

type SearchFormProps = TextFieldProps;

export default function SearchField(props: SearchFormProps) {
  const { inputProps } = useSearchInputs();

  return (
    <TextField
      color="secondary"
      variant="outlined"
      label="Search"
      inputProps={inputProps}
      sx={{
        fieldset: { borderColor: 'secondary.light' },
      }}
      InputProps={{ endAdornment: <Icon name="search" /> }}
      {...props}
    />
  );
}
